import { publicClient, privateClient } from './client';
import { DeliveryDetails } from './DeliveryDetails';

const customDeliveryDetails = (pub: boolean) => new DeliveryDetails(pub ? publicClient : privateClient);
export default customDeliveryDetails;
